export const GET_DATA_INFOMATION = "export const EDIT_DATA_INFOMATION ";
export const EDIT_DATA_INFOMATION = "EDIT_DATA_INFOMATION";
